<template>
  <svg :width="size" :height="size" viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="2">
    <path d="M24 4v8m0 24v8M4 24h8m24 0h8" stroke-linecap="round"/>
    <circle cx="24" cy="24" r="10"/>
    <path d="M24 20v4l3 3" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: "IconConnection",
  props: {
    size: { type: [Number, String], default: 48 },
  },
};
</script>
